import { useEffect, useState } from "react";
import "./tableau.css";

const TABLEAU_API_URL = "https://us-west-2b.online.tableau.com/javascripts/api/tableau.embedding.3.latest.min.js";
const TABLEAU_VIEW_URL = "https://us-west-2b.online.tableau.com/t/mindgame/views/mindGAME_17936835605890/EntermindGAME";

export default function Tableau() {
  const [scriptError, setScriptError] = useState(false);

  useEffect(() => {
    if (window.customElements?.get("tableau-viz")) return undefined;

    const existingScript = document.getElementById("tableau-embedding-api");
    if (existingScript) return undefined;

    let active = true;
    const script = document.createElement("script");
    script.id = "tableau-embedding-api";
    script.type = "module";
    script.src = TABLEAU_API_URL;
    script.addEventListener("load", () => {
      script.dataset.loaded = "true";
    }, { once: true });
    const handleError = () => {
      if (active) setScriptError(true);
    };
    script.addEventListener("error", handleError);
    document.head.appendChild(script);

    return () => {
      active = false;
      script.removeEventListener("error", handleError);
      if (!script.dataset.loaded) script.remove();
    };
  }, []);

  return (
    <main className="tableau-legacy-page" aria-label="mindGAME Tableau">
      {scriptError && (
        <p className="tableau-legacy-error" role="alert">
          The Tableau embed could not be loaded. Open the original view directly.
        </p>
      )}
      <tableau-viz
        id="tableau-viz"
        src={TABLEAU_VIEW_URL}
        width="100%"
        height="100%"
        hide-tabs=""
        toolbar="bottom"
      />
      <a
        className="tableau-legacy-fallback"
        href={TABLEAU_VIEW_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        Open original Tableau view ↗
      </a>
    </main>
  );
}
